import clsx from 'clsx';
import styles from './Inline.module.css';

/** @typedef {import('../types').SpaceToken} SpaceToken */

/**
 * @typedef {Object} InlineOwnProps
 * @property {SpaceToken} [space='md'] - Gap between children, from the space token scale.
 * @property {'start' | 'center' | 'end' | 'stretch'} [align='center'] - Cross-axis alignment (`align-items`).
 * @property {'start' | 'center' | 'end' | 'space-between' | 'space-around'} [justify='start'] - Main-axis alignment (`justify-content`).
 * @property {boolean} [wrap=true] - Whether children wrap onto multiple lines (`flex-wrap`).
 * @property {import('react').ElementType} [as='div'] - Element/component to render as.
 * @property {import('react').ReactNode} children
 */

/** @typedef {InlineOwnProps & Omit<import('react').HTMLAttributes<HTMLElement>, 'children'>} InlineProps */

/**
 * @param {InlineProps} props
 */
const Inline = ({
    space = 'md',
    align = 'center',
    justify = 'start',
    wrap = true,
    as: Component = 'div',
    className,
    style,
    children,
    ...rest
}) => {
    const mergedStyle = {
        ...style,
        gap: `var(--space-${space})`,
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap ? 'wrap' : 'nowrap',
    };

    return (
        <Component className={clsx(styles.vecInline, className)} style={mergedStyle} {...rest}>
            {children}
        </Component>
    );
};

export default Inline;
